import { Link } from '@superhi/design'
import React from 'react'

import { SITE_URL } from '../../../../../../../../config'

type Props = {
  url: string
}

const Hyperlink: React.FC<Props> = ({ url, children }) => {
  const isExternal = !url.includes(SITE_URL)
  const parsedUrl = isExternal ? url : url.split(SITE_URL)[1]

  return (
    <Link href={parsedUrl} isExternal={isExternal}>
      {children}
    </Link>
  )
}

export default Hyperlink
